import { handleEntityFetchParams } from '../common/util/EntityUtils';
import { request } from '../common/util/RestClient';
import envConfig from '../config';
import constants from '../common/constants/CommonConstants';

function getOrganizations(displayCurrency, payload) {
  const [urlQueryString, body] = handleEntityFetchParams(
    payload,
    displayCurrency,
    constants.ORGANIZATION_LEVEL
  );

  let URL = `${envConfig.APIG_URL}core/organizations?${urlQueryString}`;
  if (body) {
    const config = {
      method: 'POST',
      payload: body,
    };
    URL = `${envConfig.APIG_URL}core/organizations/get-by-ids?${urlQueryString}`;

    return request(URL, config);
  }
  return request(URL);
}
function getOrganizationsStatBar(displayCurrency, payload) {
  const [urlQueryString, body] = handleEntityFetchParams(
    payload,
    displayCurrency,
    constants.ACCOUNT_LEVEL
  );

  let URL = `${envConfig.APIG_URL}core/organizations/stat-bar?${urlQueryString}`;
  if (body) {
    const config = {
      method: 'POST',
      payload: body,
    };
    URL = `${envConfig.APIG_URL}core/organizations/stat-bar/get-by-ids?${urlQueryString}`;

    return request(URL, config);
  }
  return request(URL);
}

export default { getOrganizationsStatBar, getOrganizations };
